import React, { FC, ReactNode } from 'react'

import { ApolloClient, ApolloProvider, from, HttpLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

import { noty } from 'Utils'

import cache from './cache'

interface Props {
  children: ReactNode
  serverSide?: boolean
}

const formatGraphQLErrorMessage = (message: string): string => {
  if (!message) return 'Something went wrong'

  const extractedMessage = message.match(/message:\s*"([^"]+)"/)?.[1]
  if (extractedMessage) return extractedMessage

  return message
}

const GQLProvider: FC<Props> = ({ serverSide, children }) => {
  const errorLink = onError(({ graphQLErrors }) =>
    graphQLErrors?.forEach(({ message }) => noty(formatGraphQLErrorMessage(message))),
  )
  const httpLink = new HttpLink({
    uri: serverSide ? '' : '/graphql',
    // @ts-ignore: fetch is not defined on server side
    fetch: serverSide ? async () => {} : fetch,
  })

  const client = new ApolloClient({
    cache: cache,
    link: from([errorLink, httpLink]),
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default GQLProvider
